import {QuickAddItemType} from "../../../../../app/quick-add/@types"
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import newDocument_getMyTemplates from "../../../../../app/quick-add/sections/structure/page/helpers/get-my-templates"
import menuAdd_getDocumentTemplates from "./get-page-templates"
import {NavigationMenuInlineAddParams, NavigationMenuInlineAddType} from "../@types"

// const debug = "navigationMenuAdd_initDocuments"
const debug = false

type Params = {
    projectId?          : ID
    disableNewDocument  : boolean
    disableNewView      : boolean
    hidePopover         : func
    onAddInline         : {(inlineAddType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams):void}
}

// Page, Whiteboard, Dashboard and Portfolio options
export default function navigationMenuAdd_initDocuments(options:Options, params:Params) {

    const onAddPage = (templateId: ID) => {
        debug && console.log(debug, 'onAddPage', templateId)

        params.onAddInline(NavigationMenuInlineAddType.PAGE, {templateId})
    }

    const onAddWhiteboard = () => {
        params.onAddInline(NavigationMenuInlineAddType.WHITEBOARD)
    }

    const onAddDashboard = () => {
        params.hidePopover()

        gd.openNew(QuickAddItemType.DASHBOARD, {
            parentProjectId : params.projectId,
            type            : ViewType.CUSTOM_VIEW_DASHBOARD
        })
    }

    const onAddPortfolio = () => {
        params.hidePopover()

        gd.openNew(QuickAddItemType.PORTFOLIO, {
            parentProjectId : params.projectId,
            type            : ViewType.PROJECTS_PORTFOLIO
        })
    }

    const myDocumentTemplates       = newDocument_getMyTemplates()
    const documentTemplatesOptions  = menuAdd_getDocumentTemplates(myDocumentTemplates, onAddPage)
    const isAnyPageTemplate         = myDocumentTemplates.length > 1

    options.push({
        type        : isAnyPageTemplate ? PopoverMenuItemType.SUBMENU : null,
        icon        : 'isvg-page-small',
        label       : 'Page',
        disabled    : params.disableNewDocument,
        onClick     : onAddPage,
        options     : documentTemplatesOptions
    })

    options.push({
        icon        : 'isvg-whiteboard-small',
        label       : 'Whiteboard',
        disabled    : params.disableNewDocument,
        onClick     : onAddWhiteboard,
    })

    options.push({
        icon        : 'isvg-dashboard-small',
        label       : 'Dashboard',
        disabled    : params.disableNewView,
        onClick     : onAddDashboard
    })

    options.push({
        icon        : 'isvg-portfolio-small',
        label       : 'Portfolio',
        disabled    : params.disableNewView,
        onClick     : onAddPortfolio
    })
}
